import { fileApi } from "@/getinfo-api/index";

export interface FileApiLsParams {
  diskId: string;
  path?: string;
  type?: "file" | "dir";
  patterns?: Array<string>;
  mimeTypes?: Array<string>;
  sort?: "name" | "modifiedAt" | "size";
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: FileApiLsParams, options?: any) => {
  return fileApi.FileApiV2.ls(
    params.diskId,
    params.path,
    params.type,
    params.patterns,
    params.mimeTypes,
    params.sort,
    params.order,
    params.offset,
    params.limit,
    options
  );
};
